export default "/images/logo.png?833236dd28feb98dd78b7801f0f42c79";